import { makeStyles } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import React, { FC, ReactElement } from "react";
import { Layout, Sidebar } from "react-admin";
import AppBar from "../layout/AppBar";
import { TPMaterialTheme } from "../tp-materialui";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    padding: theme.spacing(2),
    margin: "auto",
    maxWidth: 800,
    textAlign: "center",
  },
}));

export interface CustomLayoutPageProps {
  menu: any;
  children: ReactElement<any, any>;
  [x: string]: any;
}

const CustomLayoutPage: FC<CustomLayoutPageProps> = ({
  children,
  menu,
  ...rest
}) => {
  const classes = useStyles();
  const getSideBar = (props) => <Sidebar {...props} size={200} />;
  return (
    <Layout
      {...rest}
      // @ts-ignore
      appBar={AppBar}
      sidebar={getSideBar}
      theme={TPMaterialTheme}
      menu={menu}
    >
      <div className={classes.root}>
        <Container className={classes.container}>{children}</Container>
      </div>
    </Layout>
  );
};

export default CustomLayoutPage;
